export function getSpectrumErrorValue(spectrum) {
    const { x } = spectrum.data;
    return (x[x.length - 1] - x[0]) / 10000;
}
//# sourceMappingURL=getSpectrumErrorValue.js.map